import { OnlyViewHoc } from 'hocs'
import React, { useEffect } from 'react'

import { getFio } from 'helpers/formatText'
import { useParams } from 'hooks/useParams'
import { useGetSupervisorsQuery } from 'redux/services/common'

import { AppButton } from 'components/AppButton'
import { AppFiltersLayout } from 'components/AppFiltersLayout'
import { AppSelect } from 'components/AppSelect'
import { TextField } from 'components/TextField'
import { KG_PHONE_MAX_LENGTH } from 'components/TextFieldPhone'

import { CalculatorType, GetAttractorsParamsType } from 'models/payout'
import { Region } from 'models/region'

interface Props {
  regions: Region[]
  calcs: CalculatorType[]
  onSubmit?(values: GetAttractorsParamsType): void
  downloadExcel(values: GetAttractorsParamsType): void
  downloadingExcel: boolean
}

const defaultListValue = {
  title: 'Все',
  value: '',
}

export const AttractorDetailsHeader: React.FC<Props> = ({
  regions,
  calcs,
  onSubmit,
  downloadExcel,
  downloadingExcel,
}) => {
  const { params, setParam, setDebounceParam, clearParams } = useParams()
  const { data: supervisors } = useGetSupervisorsQuery()

  const regionList = regions.map(item => ({
    title: item.name,
    value: item.id,
  }))
  const calcList = calcs.map(item => ({
    title: item.plan.name,
    value: item.id,
  }))

  function _submit() {
    const _params = {
      ...params,
      supervisor:
        params.supervisor?.length === KG_PHONE_MAX_LENGTH
          ? params.supervisor
          : '',
    }
    onSubmit?.(_params)
  }

  useEffect(() => {
    _submit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.supervisor, params.future_calc_id, params.region, params.search])

  function _reset() {
    clearParams()
    onSubmit?.({})
  }

  function _handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = e.target
    setDebounceParam(name, value)
  }

  const selectedSupervisorText = getFio(
    supervisors?.results?.find(s => s.phone === params.supervisor),
  )

  return (
    <AppFiltersLayout
      controls={
        <>
          <AppButton size="small" onClick={_submit}>
            Применить
          </AppButton>
          <OnlyViewHoc>
            <AppButton
              onClick={() => downloadExcel(params)}
              disabled={downloadingExcel}
              variant="siren"
              size="small"
            >
              Скачать Excel Bonus
            </AppButton>
            <AppButton size="small" variant="red" onClick={_reset}>
              Сбросить
            </AppButton>
          </OnlyViewHoc>
        </>
      }
    >
      <AppSelect
        size="extra_small"
        text={
          regionList.find(item => item.value === Number(params.region))?.title
        }
        onChangeValues={value => setParam('region', value?.[0] || '')}
        list={[defaultListValue, ...regionList]}
        placeholder="Все"
        label="Регион"
      />
      <AppSelect
        size="extra_small"
        text={
          calcList.find(item => item.value === Number(params.future_calc_id))
            ?.title
        }
        onChangeValues={value => setParam('future_calc_id', value?.[0] || '')}
        list={[defaultListValue, ...calcList]}
        placeholder="Все"
        label="След. Калькулятор"
      />
      <TextField
        inputSize="small"
        onChange={_handleChange}
        defaultValue={params.search || ''}
        name="search"
        label="ФИО"
        placeholder="Фамилия Имя Отчество"
      />
      <AppSelect
        size="extra_small"
        label="Выберите супервайзера"
        text={selectedSupervisorText}
        onChangeValues={([selectedValue]) => {
          setParam('supervisor', selectedValue)
        }}
        list={[
          defaultListValue,
          ...(supervisors?.results || []).map(item => ({
            value: item.phone,
            title: getFio(item),
          })),
        ]}
      />
    </AppFiltersLayout>
  )
}
